import { createFileRoute, Navigate } from '@tanstack/react-router';

function IndexPage() {
  return <Navigate to="/dashboard" />;
}

export const Route = createFileRoute('/_authenticated/')({
  component: IndexPage,
});
